"use client";

const USPIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
  >
    {/* ... (SVG code remains the same) ... */}
    <rect width="60" height="61" fill="#0091E3" />
    <g clipPath="url(#clip0_3771_11563)">
      <mask
        id="mask0_3771_11563"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="11"
        width="39"
        height="39"
      >
        <path
          d="M10.3281 11.3331H48.3281V49.3331H10.3281V11.3331Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3771_11563)">
        <path
          d="M30.5858 22.5991L34.0139 24.4014L33.3592 20.5841L36.1325 17.8807L32.2999 17.3238L30.5858 13.8508L28.8717 17.3238L25.0391 17.8807L27.8124 20.5841L27.1577 24.4014L30.5858 22.5991Z"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
        <path
          d="M26.1328 43.7667L19.4531 14.673L26.2687 17.7021"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M33.4141 20.8757L39.4969 23.5792L35.0438 43.7667"
        stroke="white"
        strokeWidth="2.22656"
        strokeMiterlimit="10"
      />
      <mask
        id="mask1_3771_11563"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="11"
        width="39"
        height="39"
      >
        <path
          d="M10.3281 11.3331H48.3281V49.3331H10.3281V11.3331Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3771_11563)">
        <path
          d="M23.9062 48.2198V45.9933C23.9062 44.7636 24.9032 43.7667 26.1328 43.7667H35.0391C36.2687 43.7667 37.2656 44.7636 37.2656 45.9933V48.2198"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
        <path
          d="M27.25 30.3331H33.9297"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
        <path
          d="M27.25 34.7863H33.9297"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
        <path
          d="M20.5703 48.2198H40.6094"
          stroke="white"
          strokeWidth="2.22656"
          strokeMiterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3771_11563">
        <rect
          width="38"
          height="38"
          fill="white"
          transform="translate(10.3281 11.333)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default function CourseUSPSection({ course }) {
  if (!course?.USP || course.USP.length === 0) {
    return null;
  }

  const gradientStyles = [
    {
      backgroundImage:
        "radial-gradient(circle 300px at 50% 100%, rgba(0, 145, 227, 0.4) 0%, rgba(8, 30, 45, 1) 80%)",
    },
     {
      backgroundImage:
        "radial-gradient(circle 300px at 50% 100%, rgba(255, 162, 12, 0.4) 0%, rgba(8, 30, 45, 1) 80%)",
    },
    {
      backgroundImage:
        "radial-gradient(circle 300px at 50% 100%, rgba(0, 145, 227, 0.4) 0%, rgba(8, 30, 45, 1) 80%)",
    }
  ];

  return (
    <section className="page-container pt-[20px]">
      <div className="flex flex-col xl:flex-row xl:flex-no-wrap gap-[16px] md:gap-[20px] justify-center">
        {course.USP.map((usp, index) => {
          const style = gradientStyles[index % gradientStyles.length];
          return (
            <div
              key={index}
              className={`flex w-full overflow-hidden text-white bg-[#081E2D]`}
              style={style}
            >
              <div className="flex items-center px-[17px] py-[22px] w-full">
                <div className="mr-4 flex-shrink-0">
                  {USPIcon}
                </div>
                
                <div className="flex-grow">
                  <p className="text-sm md:text-base font-semibold leading-snug">
                    {usp.USPText} 
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}